





































import { Component, Vue, Prop } from "vue-property-decorator";
import { State, Action, Getter, Mutation } from "vuex-class";
import { pageDataType } from "../types";
import { HOST } from "../global";
import { pageData } from "@/store/pageData";
import VideoCard from "@/components/VideoCard.vue";
import OppertunityCard from "@/components/OppertunityCard.vue";
import MissionCard from "@/components/MissionCard.vue";
import ComplianceCard from "@/components/ComplianceCard.vue";
import NewssliderCard from "@/components/NewssliderCard.vue";
import HeaderText from "../components/HeaderText.vue";
import HomeSlider from "../components/HomeSlider.vue";
import Achievments from "@/components/Achievments.vue";

@Component({
  name: "HomePage",
  components: {
    slider: HomeSlider,
    title_subtitle_text_overlay_image: ComplianceCard,
    title_subtitle_stream_block: MissionCard,
    title_text_one_side_image: OppertunityCard,
    youtube_video_block: VideoCard,
    title_text_cta: HeaderText,
    achievement_block: Achievments,
    title_subtitle_newslist: NewssliderCard,
  },
})
export default class HomePage extends Vue {
  @Prop() public pageData!: pageDataType;
  @Getter("pageType") public pageType!: string | null;
  public HOST: string = HOST;
}
